const common =
  "ar ca cs da de el en es fa fi fr he hi hu id it ja ko nl no pl pt ro ru sv th tr uk vi zh".split(
    " ",
  );

export interface LanguageChoice {
  readonly code: string;
  readonly name: string;
}

/** Languages to offer for a post: the writer's own first, in order, then common ones by name. */
export function languageChoices(
  preferred: readonly string[],
  displayLocale: string,
): LanguageChoice[] {
  const names = new Intl.DisplayNames([displayLocale], { type: "language" });
  const choice = (code: string) => ({ code, name: names.of(code) ?? code });
  const own = [
    ...new Set(preferred.flatMap((tag) => {
      try {
        return [new Intl.Locale(tag).language];
      } catch {
        return [];
      }
    })),
  ];
  const rest = common.filter((code) => !own.includes(code)).map(choice)
    .sort((a, b) => a.name.localeCompare(b.name, displayLocale));
  return [...own.map(choice), ...rest];
}
